import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'

const Commissions = _ => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [rows, setRows] = useState({
        customer: {},
        details: [],
        exchange: [],
        total_earnings: 0
    })

    useEffect(() => {
        setIsProccesing(true)
        Controllers.red.get_my_commissions().then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setIsProccesing(false)
        })
    }, [])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center', sort: false, classBodyTr: r => {
                    return parseInt(r?.has_exchange) === 1 ? 'bg-info text-white' : ''
                } },
                { name: 'full_name', text: 'Nombres', sort: false },
                { name: 'point_business_customers', text: 'Valor Negocio', align: 'center', sort: false },
                { name: 'percentage', text: 'Porcentaje', align: 'center', sort: false, render: r => r.percentage + '%' },
                { name: 'subtotal_earnings', text: 'Ganancia', align: 'center', sort: false, render: r => '$ ' + r.subtotal_earnings },
                { name: 'nivel', text: 'Nivel', align: 'center', sort: false },
                { name: 'code_money', text: 'Moneda', align: 'center', sort: false },
            ],
        ]}
        rows={rows.details}
        pageLength={100}
        isProcessing={isProcessing}
        noSort
    />, [rows, isProcessing])

    return <div className="ui-page">
        <div className="ui-page-head">
            <div>
                <h1 className="ui-page-title">Comisiones</h1>
                <p className="ui-page-meta">Detalle por consultor y conversiones</p>
            </div>
        </div>

        {!isProcessing ? <div className="ui-summary-strip">
            <Card className="ui-metric-card is-primary mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Total comisiones</span>
                    <div className="ui-metric-value" style={{ fontSize: '1.1rem' }}>
                        {rows.customer.code_money} {parseFloat(rows.total_earnings).toFixed(2)}
                    </div>
                </Card.Body>
            </Card>
            <Card className="ui-metric-card mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Líneas</span>
                    <div className="ui-metric-value">{rows.details?.length || 0}</div>
                </Card.Body>
            </Card>
            <Card className="ui-metric-card mb-0">
                <Card.Body className="text-center py-3">
                    <span className="ui-metric-label">Conversiones</span>
                    <div className="ui-metric-value">{rows.exchange?.length || 0}</div>
                </Card.Body>
            </Card>
        </div> : null}

        <Card className="ui-list-shell border-0">
            <Card.Header>
                <span>Detalle de comisiones</span>
            </Card.Header>
            <Card.Body>
                { dtRows }
            </Card.Body>
        </Card>

        {isProcessing ? '' : <>
            {rows.exchange.length > 0 ? <Card className="ui-list-shell border-0">
                <Card.Header>
                    <span>Detalle de Conversiones</span>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <table className="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>Moneda</th>
                                    <th>Ganancia</th>
                                    <th>Conversión</th>
                                    <th>Ganancia Conversión</th>
                                </tr>
                            </thead>
                            <tbody>
                                {React.Children.toArray(rows.exchange.map(e => {
                                    return <tr>
                                        <td>{e.full_name}</td>
                                        <td align="center">{e.code_money}</td>
                                        <td align="center">{e.subtotal_earnings}</td>
                                        <td align="center">{e.value_exchange}</td>
                                        <td align="center">{e.subtotal_exchange}</td>
                                    </tr>
                                }))}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card> : ''}
            <div className="ui-totals-panel">
                <div className="ui-totals-row is-total" style={{ borderTop: 'none', marginTop: 0, paddingTop: 0 }}>
                    <span>Total de Comisiones</span>
                    <span>{rows.customer.code_money} {parseFloat(rows.total_earnings).toFixed(2)}</span>
                </div>
                <p className="ui-page-meta mb-0 mt-2">Total de comisiones antes de impuesto.</p>
            </div>
        </>}
    </div>
}

export default Commissions
